@if (!isReadOnly) {
  <div class="notreadOnly rate" id="rate-{{ this.css }}">
    @for (index of [3, 2, 1]; track index) {
      <dx-button
        (onClick)="clickMark(index)"
        (mouseover)="mouseover(index)"
        (mouseout)="mouseout(index)"
        icon="mdi mdi-star"
        [ngClass]="value >= index || valueOver >= index ? 'mark' : ''"></dx-button>
    }
  </div>
}

@if (isReadOnly) {
  <div class="readOnly rate" id="rate-{{ this.value }}">
    @for (index of [3, 2, 1]; track index) {
      <dx-button [disabled]="true" icon="mdi mdi-star" [ngClass]="value >= index ? 'mark' : ''"></dx-button>
    }
  </div>
}
